import React from "react";
import { MapPin } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { archiveEvents, interdanzaEditions } from "../mock/mock";

const Archivio = () => {
  const { t, pick } = useLang();

  return (
    <div>
      <PageHero
        image="https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/ohwa3qde_DSC8942.jpg"
        kicker="arts4all"
        title={t("archive.title")}
        lead={t("archive.lead")}
      />

      {/* EVENTS */}
      <section className="bg-[#faf7f2] py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8 space-y-16">
          {archiveEvents.map((e, i) => (
            <Reveal
              key={i}
              className={`grid lg:grid-cols-2 gap-10 items-center ${
                i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div className="aspect-[16/11] overflow-hidden group">
                <img
                  src={e.image}
                  alt={pick(e.title)}
                  className="w-full h-full object-cover object-top transition-transform duration-[1400ms] group-hover:scale-105"
                />
              </div>
              <div>
                <span className="font-serif text-5xl text-[#b5533a]">{e.year}</span>
                <h2 className="mt-3 font-serif text-3xl md:text-4xl text-[#1c1b1a] leading-snug">
                  {pick(e.title)}
                </h2>
                <p className="mt-2 inline-flex items-center gap-2 text-sm text-[#8a8478]">
                  <MapPin className="w-4 h-4" /> {pick(e.place)}
                </p>
                <p className="mt-5 text-[#3d3a35] leading-relaxed">{pick(e.text)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* INTERDANZA EDITIONS LIST */}
      <section className="bg-white py-20 lg:py-28">
        <div className="mx-auto max-w-5xl px-5 lg:px-8">
          <Reveal className="mb-12">
            <h2 className="font-serif text-4xl md:text-5xl text-[#1c1b1a]">
              {t("archive.interdanzaTitle")}
            </h2>
          </Reveal>
          <div className="grid sm:grid-cols-2 gap-x-12">
            {interdanzaEditions.map((e, i) => (
              <Reveal
                key={e.year}
                delay={(i % 2) * 60}
                className="flex items-baseline gap-5 py-4 border-b border-[#eae4d9]"
              >
                <span className="font-serif text-xl text-[#b5533a] w-14 shrink-0">{e.year}</span>
                <div>
                  <span className="font-serif text-lg text-[#1c1b1a]">{pick(e.title)}</span>
                  {e.author && (
                    <span className="text-sm text-[#8a8478] italic"> — {e.author}</span>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Archivio;
